import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 486.000000 514.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,514.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M2273 3881 c-12 -8 -296 -503 -296 -516 0 -6 50 -97 111 -203 l112
-193 -51 -90 c-28 -49 -55 -92 -59 -94 -5 -3 -47 61 -94 142 -145 253 -135
239 -150 217 -8 -11 -151 -258 -320 -551 -264 -459 -306 -537 -306 -573 l0
-40 321 2 322 3 106 187 c58 103 111 187 116 187 6 1 49 -68 97 -152 l86 -152
45 -3 44 -3 89 156 c49 85 93 154 98 152 5 -2 57 -86 115 -187 l107 -185 322
-3 322 -2 0 39 c0 40 7 27 -500 909 -74 127 -137 232 -140 232 -3 0 -54 -86
-113 -190 -60 -105 -112 -188 -117 -185 -5 3 -32 46 -60 95 l-51 89 112 193
c61 106 112 198 112 203 -1 11 -253 453 -283 494 -17 24 -75 37 -97 22z m104
-426 c28 -49 50 -92 49 -95 -21 -40 -109 -180 -114 -180 -11 0 -107 180 -104
193 9 31 98 176 107 173 5 -1 33 -42 62 -91z m-457 -795 l51 -89 -113 -195
-113 -196 -113 0 -114 0 25 43 c13 23 88 153 167 289 78 136 146 245 151 243
4 -3 31 -46 59 -95z m459 -2 l50 -88 -54 -90 c-29 -50 -56 -92 -59 -93 -4 -1
-31 40 -61 92 l-55 94 47 81 c57 100 64 109 74 99 4 -4 30 -47 58 -95z m551
-165 c85 -148 160 -278 168 -290 l14 -23 -114 0 -115 0 -112 195 c-62 107
-111 199 -109 203 10 26 104 182 109 182 3 0 75 -120 159 -267z"
          />
          <path
            d="M1858 1883 c-10 -3 -18 -13 -18 -23 0 -23 -20 -70 -30 -70 -4 0 -7
-7 -7 -15 0 -8 4 -15 8 -15 9 0 34 41 31 50 -3 10 10 40 17 40 5 0 14 -20 20
-45 7 -28 17 -45 26 -45 19 0 19 0 -1 63 -20 60 -23 65 -46 60z"
          />
          <path
            d="M2283 1883 c-7 -2 -13 -9 -13 -14 0 -5 -7 -26 -16 -47 -23 -50 -24
-62 -9 -62 13 0 26 23 30 52 4 36 22 38 28 2 7 -36 19 -54 37 -54 16 0 16 5
-5 62 -23 62 -29 71 -52 61z"
          />
          <path
            d="M2608 1882 c-10 -2 -18 -11 -18 -20 0 -9 -9 -36 -20 -59 -15 -34 -16
-43 -5 -43 13 0 17 8 29 63 7 32 26 36 33 7 3 -11 9 -17 14 -14 5 3 9 0 9 -5
0 -6 -4 -11 -9 -11 -5 0 -7 -9 -4 -20 3 -11 13 -20 23 -20 16 0 16 4 -4 59
-25 68 -25 69 -48 63z"
          />
          <path
            d="M1224 1864 c3 -9 6 -36 6 -60 l0 -45 48 3 c40 3 47 6 50 25 2 14 -4
26 -20 34 -21 11 -22 11 -9 -4 11 -14 11 -20 1 -32 -21 -26 -50 -19 -52 13 0
15 -2 32 -3 37 -2 6 -3 18 -4 28 0 9 -6 17 -12 17 -6 0 -8 -7 -5 -16z"
          />
          <path
            d="M1952 1828 c3 -46 6 -54 31 -66 22 -11 32 -11 55 0 24 12 27 20 30
66 2 41 0 52 -12 52 -11 0 -16 -14 -18 -52 -2 -42 -7 -54 -22 -56 -28 -6 -39
13 -38 63 2 35 -1 45 -13 45 -13 0 -15 -10 -13 -52z"
          />
          <path
            d="M2100 1820 c0 -47 3 -60 15 -60 8 0 15 7 15 15 0 22 28 18 35 -5 6
-20 25 -26 38 -13 4 3 2 12 -5 20 -8 10 -8 17 0 25 15 15 15 51 0 66 -7 7 -31
12 -55 12 l-43 0 0 -60z m80 19 c0 -19 -33 -43 -44 -32 -7 8 -8 48 0 55 11 12
44 -5 44 -23z"
          />
          <path
            d="M2426 1823 l2 -58 40 -3 c47 -4 72 16 72 57 0 38 -28 61 -76 61 l-40
0 2 -57z m68 34 c12 -9 17 -23 14 -47 -3 -30 -7 -35 -28 -35 -21 0 -26 5 -28
33 -6 58 8 74 42 49z"
          />
          <path
            d="M2710 1867 c14 -7 27 -10 30 -6 3 4 16 9 30 12 14 2 0 5 -30 5 -51 2
-53 1 -30 -11z"
          />
          <path
            d="M2830 1870 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11
0 -20 -4 -20 -10z"
          />
          <path d="M2985 1871 c-3 -6 12 -10 35 -9 22 0 40 4 40 9 0 12 -67 12 -75 0z" />
          <path
            d="M3100 1871 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"
          />
          <path
            d="M3190 1870 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"
          />
          <path
            d="M3246 1866 c7 -19 9 -19 33 -4 15 9 25 9 46 0 21 -10 26 -10 23 0 -3
8 -26 14 -56 16 -43 3 -51 1 -46 -12z"
          />
          <path
            d="M1363 1775 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9
-1 -9 -9z"
          />
          <path
            d="M2727 1783 c-13 -12 -7 -23 11 -22 10 0 12 3 4 6 -6 2 -10 9 -6 14 6
10 0 12 -9 2z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
